import BkDataTable from './bk-data-table';

async function getStyle(style) {
    if (style === 'CM') {
        await import('./assets/cm-bk-data-table.css');
    } else if (style === 'RM') {
        await import('./assets/rm-bk-data-table.css');
    } else if (style === 'AM') {
        await import('./assets/am-bk-data-table.css');
    }
}

const bkDataTableInit = (params) => {
    getStyle(params.style);
    customElements.define('bk-data-table', BkDataTable);
};

export default bkDataTableInit;
